import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {  Mail } from 'lucide-react';
import CustomAppBar from '../../../mainComponents/appBar';

const faqs = [
  {
    question: 'Someone is bullying me 😞',
    answer: 'Go to Settings > Blocked Users and add them. You can also pause your link anytime for peace.',
  },
  {
    question: 'How do I block someone? 🚫',
    answer: 'Tap on their message > More > Block. You’ll never see messages from them again.',
  },
  {
    question: 'Can I turn off messages? 🔕',
    answer: 'Yes! Just use the “Pause my link” option under Safety controls.',
  },
  {
    question: 'What is NGL exactly? 🤔',
    answer: 'NGL lets friends send anonymous messages. It’s designed to be fun — but we take your safety seriously.',
  },
];

export default function HelpScreen() {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="flex justify-center bg-[#f5f5f5] overflow-hidden no-scrollbar pt-10 h-screen px-4 py-6 text-black font-[SF Pro Display]">
      <div className="w-full max-w-sm">
        {/* Header */}
        <CustomAppBar
          title="Help & Support"
        />

        {/* FAQs */}
        <div className="space-y-4 mt-5">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-4 shadow-md cursor-pointer transition"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
            >
              <p className="font-semibold text-[15px]">{item.question}</p>
              {openIndex === i && (
                <p className="mt-2 text-sm text-gray-600 transition-opacity duration-300">
                  {item.answer}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Mail Us */}
        <div className="mt-8">
          <button
            onClick={() => window.location.href = 'mailto:support@squadco.com'}
            className="flex items-center justify-center w-full bg-black text-white py-3 px-4 rounded-2xl font-semibold text-sm shadow-md"
          >
            <Mail className="w-4 h-4 mr-2" />
            Still need help? Mail us
          </button>
        </div>
      </div>
    </div>
  );
}

